// src/utils/anonimizador.js
class AnonimizadorJuridico {
  constructor() {
    // Padrões para identificação de dados sensíveis em Portugal
    this.padroes = {
      // Números de telemóvel portugueses
      telemovel: {
        regex: /(\+351\s?)?([92][0-9]{8}|9[13-9][0-9]{7})/g,
        substituto: '[TELEMÓVEL_ANONIMIZADO]'
      },
      
      // Cartão de Cidadão (formato: 12345678 9 ZZ0)
      cartaoCidadao: {
        regex: /\b\d{8}\s*\d\s*[A-Z]{2}\d\b/g,
        substituto: '[CC_ANONIMIZADO]'
      },
      
      // NIF (Número de Identificação Fiscal)
      nif: {
        regex: /\bNIF[\s:]*\d{9}\b/gi,
        substituto: 'NIF [NIF_ANONIMIZADO]'
      },
      
      // Número de Identificação da Segurança Social
      niss: {
        regex: /\bNISS[\s:]*\d{11}\b/gi,
        substituto: 'NISS [NISS_ANONIMIZADO]'
      },
      
      // Números de documento isolados (9-11 dígitos)
      numeroDocumento: {
        regex: /\b\d{9,11}\b/g,
        substituto: '[DOCUMENTO_ANONIMIZADO]'
      },
      
      // Matrículas portuguesas (formato: XX-XX-XX ou XX-00-XX)
      matricula: {
        regex: /\b[A-Z0-9]{2}-[A-Z0-9]{2}-[A-Z0-9]{2}\b/g,
        substituto: '[MATRÍCULA_ANONIMIZADA]'
      },
      
      // E-mails
      email: {
        regex: /\b[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Z|a-z]{2,}\b/g,
        substituto: '[EMAIL_ANONIMIZADO]'
      },
      
      // Endereços (padrão simplificado)
      endereco: {
        regex: /\b(Rua|Avenida|Travessa|Largo|Praça|Estrada)\s+[^,\n]{10,50}/gi,
        substituto: '[ENDEREÇO_ANONIMIZADO]'
      },
      
      // Códigos postais portugueses
      codigoPostal: {
        regex: /\b\d{4}-\d{3}\b/g,
        substituto: '[CÓDIGO_POSTAL_ANONIMIZADO]'
      },
      
      // IBAN português
      iban: {
        regex: /\bPT50\s?\d{4}\s?\d{4}\s?\d{4}\s?\d{4}\s?\d{4}\s?\d{1}\b/gi,
        substituto: '[IBAN_ANONIMIZADO]'
      }
    };
    
    // Contador para diferentes instâncias do mesmo tipo
    this.contadores = {};
  }

  anonimizar(texto) {
    if (!texto || typeof texto !== 'string') {
      return texto;
    }

    let textoAnonimizado = texto;
    
    // Reset contadores para cada nova anonimização
    this.contadores = {};
    
    // Aplica cada padrão de anonimização
    Object.entries(this.padroes).forEach(([tipo, config]) => {
      textoAnonimizado = textoAnonimizado.replace(config.regex, (match) => {
        return this.obterSubstitutoNumerado(tipo, config.substituto);
      });
    });
    
    return textoAnonimizado;
  }
  
  obterSubstitutoNumerado(tipo, substitutoBase) {
    if (!this.contadores[tipo]) {
      this.contadores[tipo] = 0;
    }
    this.contadores[tipo]++;
    
    // Se houver múltiplas ocorrências, numera elas
    if (this.contadores[tipo] > 1) {
      return substitutoBase.replace(']', `_${this.contadores[tipo]}]`);
    }
    
    return substitutoBase;
  }
  
  // Método para verificar se o texto contém dados sensíveis
  contemDadosSensiveis(texto) {
    if (!texto || typeof texto !== 'string') {
      return false;
    }
    
    return Object.values(this.padroes).some(config => 
      config.regex.test(texto)
    );
  }
  
  // Método para listar tipos de dados encontrados
  tiposDadosEncontrados(texto) {
    if (!texto || typeof texto !== 'string') {
      return [];
    }
    
    const tiposEncontrados = [];
    
    Object.entries(this.padroes).forEach(([tipo, config]) => {
      if (config.regex.test(texto)) {
        tiposEncontrados.push(tipo);
      }
    });
    
    return tiposEncontrados;
  }
}

export default AnonimizadorJuridico;